import { cva } from "cva";

export const navbarLinkStyles = cva({
  base: "cursor-pointer py-10 px-16 text-ginto-15 font-normal leading-140 bg-transparent hover:bg-ink-100 focus-visible:bg-ink-100 rounded-sm text-content-primary transition-colors duration-300 ease-out-quad",
});
